import http from 'plugins/axios';

export default {
  getProcessorList() {
    return http.get({
      url: '/la/admin/processor/list'
    });
  },
  updatePendingHeight({ coinType, height, processorId }) {
    return http.post({
      url: '/la/admin/processor/update/pending',
      data: {
        coinType,
        processorId,
        height
      },
      dataType: 'form'
    });
  },
  updateConfimedHeight({ coinType, height, processorId }) {
    return http.post({
      url: '/la/admin/processor/update/confirmed',
      data: {
        coinType,
        processorId,
        height
      },
      dataType: 'form'
    });
  }
};
